// param为传入参数
function whetherInteger(obj) {
  return obj % 1 === 0
}

function corresponding(value, obj) {
  let returnValue
  let valueToString = JSON.stringify(value)
  _.forIn(obj, function (objValue, key) {
    if (valueToString === key) {
      returnValue = objValue
    }
  });
  return returnValue
}

export default {
  // Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
  install: function (Vue) {
   Vue.prototype.isInteger = (obj) => whetherInteger(obj)
  },
  
  install: function (Vue) {
    Vue.prototype.correspondingRelation = (value, obj) => corresponding(value, obj)
  }
}